export default __webpack_public_path__ + "6b0ddfc0e87d40843f37ac295e3e3f71.json";